import { SearchSource } from '@carvana/merch-contracts';
import { useSearchSource } from '~/context/srp/SearchEventsDataContext';

export default function useIsFromSearchBar() {
  const searchSource = useSearchSource();

  switch (searchSource) {
    case SearchSource.DefaultSuggestion:
    case SearchSource.RecentSearch:
    case SearchSource.SavedSearch:
    case SearchSource.TextSearch:
      return true;
    default:
      return false;
  }
}
